<template>
  <div class="columns">
    <div class="column">
      <p>Campos obrigatórios</p>
      <p class="is-size-7 mb-2">
        Lembre-se: A obrigatoriedade de campos dificulta o agendamento
      </p>
      <b-field>
        <b-checkbox
          @input="setRequiredFields"
          v-model="RequiredFields"
          native-value="birthDate"
        >
          Data Nascimento
        </b-checkbox>
      </b-field>
      <b-field>
        <b-checkbox
          @input="setRequiredFields"
          v-model="RequiredFields"
          native-value="motherName"
        >
          Nome da mãe
        </b-checkbox>
      </b-field>
      <b-field>
        <b-checkbox
          @input="setRequiredFields"
          v-model="RequiredFields"
          native-value="fatherName"
        >
          Nome da pai
        </b-checkbox>
      </b-field>
      <!-- <b-field>
        <b-checkbox
          @input="setRequiredFields"
          v-model="RequiredFields"
          native-value="cpf"
          disabled
        >
          Cpf do paciente
        </b-checkbox>
      </b-field> -->
    </div>
    <div class="column">
      <b-field
        label="Mensagem para agendamento na clinica"
        label-position="on-border"
        class="mb-1"
      >
        <b-input
          v-model="MsgOnSchedule.local"
          maxlength="200"
          type="textarea"
          rows="2"
        ></b-input>
      </b-field>
      <b-field
        label="Mensagem para agendamento online"
        label-position="on-border"
        class="mb-1"
      >
        <b-input
          v-model="MsgOnSchedule.online"
          maxlength="200"
          type="textarea"
          rows="2"
        ></b-input>
      </b-field>
      <b-button @click="setMsgOnSchedule" class="is-info">Enviar</b-button>
    </div>
    <div class="column"></div>
  </div>
</template>

<script>
export default {
  name: "OtherSettings",
  props: ["officeId", "requiredFields", "msgOnSchedule"],
  data() {
    return {
      RequiredFields: JSON.parse(JSON.stringify(this.requiredFields)),
      MsgOnSchedule: JSON.parse(JSON.stringify(this.msgOnSchedule)),
    };
  },
  methods: {
    setMsgOnSchedule() {
      this.$http.put(`office/${this.officeId}`, {
        msgOnSchedule: this.MsgOnSchedule,
      });
    },
    setRequiredFields() {
      this.$http.put(`office/${this.officeId}`, {
        requiredFields: this.RequiredFields,
      });
    },
  },
};
</script>
